import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        if(!window.yotpoWidgetsContainer) return;

        yotpoWidgetsContainer?.initWidgets();
    }
}
